<template>
  <span class="fav-btn" @click="toFavorite">
    <span>
      <img :src="imgSrc" class="fav-btn-img" />Favorites
    </span>
  </span>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const {
  mapState,
} = createNamespacedHelpers('common');
export default {
  data() {
    return {
      collectSvg: require('@/assets/image/collect.svg'),
      darkCollectSvg: require('@/assets/image/dark-collect.svg'),
    }
  },
  computed: {
    ...mapState([
      'isDark',
      'userInfo',
      'app',
      'source'
    ]),
    imgSrc() {
      return this.isDark ? this.darkCollectSvg : this.collectSvg;
    },
  },
  methods: {
    toFavorite() {
      this.reportClick();
      if (!this.userInfo) {
        this.$eventBus.$emit('login', this.jumpFavorite);
        return;
      }
      this.jumpFavorite();
    },
    jumpFavorite() {
      this.$router.push('/help-center/favorite/');
    },
    reportClick() {
      const { app, source }= this;
      this.$report('helpcenter_page', {
        action: 'click',
        comp: app,
        item: 'favorites',
        source
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.fav-btn {
  color: var(--current-default-color);
  padding: 2px;
  cursor: pointer;

  &:hover {
    background: var(--current-bg-hover-color);
    border-radius: 2px;
  }

  &-img {
    vertical-align: sub;
    margin-right: 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common-btn/fav-link.vue